import { type SafeHtml } from 'kerfjs';

import { EditableToolbarTitle } from '../../../components/editable-toolbar-title.js';
import { titleEditing, workspace } from '../../../data/state.js';

/** The open demand's title as a click-to-edit control. Kept private to AppShell,
 * but exported so the UX catalog can render the exact production component. */
export function DemandTitleControl(): SafeHtml {
  const demand = workspace.value?.demand as { title?: string; status?: string } | undefined;
  const rawTitle = demand?.title ?? '';
  const title = rawTitle !== '' && rawTitle !== 'Untitled demand' ? rawTitle : '';
  const isNew = demand?.status === 'draft' && title === '';
  const placeholder = isNew ? 'Untitled' : 'Ticket title';
  return (
    <EditableToolbarTitle
      label="Demand Title"
      hook="demand-title"
      editing={titleEditing.value}
      value={title}
      placeholder={placeholder}
      inputAction="demand-title-input"
      editAction="edit-demand-title"
      display={title !== '' ? title : placeholder}
    />
  );
}
